import validFileSize from "./valid-file-size";
import nextUploader from "./next-uploader";

export default (baseElem, beforeElem, configObj, idxElem) => {

  const idxValue = parseInt(idxElem.value) + 1
  idxElem.value = idxValue
  const nextUploadElem = baseElem.cloneNode(true)
  nextUploadElem.id = baseElem.id + idxValue
  nextUploadElem.name = baseElem.name.slice(0, baseElem.name.length - 1) + idxValue + "]"
  nextUploadElem.style.display = "block"
  beforeElem.parentNode.insertBefore(nextUploadElem, beforeElem.nextSibling)
  beforeElem.style.display = "none"

  nextUploadElem.addEventListener('change', (e) => {
    if (validFileSize(configObj.limitSizeMB, e) === false) return
    nextUploader(baseElem, nextUploadElem, configObj, idxElem)

    const files = Array.from(e.target.files || e.dataTransfer.files)
    const tmpUploadAreaElem = document.getElementById("tmp_" + configObj.elementName + "_area")

    const displayBaseTemplate = document.getElementsByClassName("base-tmp-upload-image")[0]
    files.forEach(file => {
      const tmpDisplayElem = displayBaseTemplate.cloneNode(true)
      tmpDisplayElem.classList.remove("base-tmp-upload-image")

      if (/(.jpg|.jpeg|.png|.gif)$/.test(file.name.toLowerCase())) {
        const tmpImg = tmpDisplayElem.getElementsByTagName("IMG")[0]
        tmpImg.alt = file.name
        tmpImg.width = 400
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          tmpImg.src = reader.result
          tmpDisplayElem.style.display = "block"
        }
      } else {
        tmpDisplayElem.style.display = "block"
      }
      tmpUploadAreaElem.appendChild(tmpDisplayElem)
      tmpDisplayElem.getElementsByTagName("BUTTON")[0].addEventListener('click', (e) => {
        nextUploadElem.value = ""
        tmpDisplayElem.style.display = "none"
      })
    })
  })
}